import type { ExerciseAttempt } from './types'

export function isQualifiedEvidence(attempt: ExerciseAttempt): boolean {
  if (attempt.scoringMethod === 'simulated'
    || attempt.scoringMethod === 'self-check'
    || attempt.scoringMethod === 'not-observed') return false
  return !(attempt.ability === 'speaking' && attempt.scoringMethod !== 'ise-pronunciation')
}
